import ComingSoonView from '@/components/feature/coming-soon/ComingSoonView';

export default function Home() {
  return <ComingSoonView />;
}